/**
 * Claim Form B API
 * Handles all Claim Form B operations
 */

import api from './http';

// Base endpoint with API version prefix
const BASE_URL = '/api/v1/claim-form-b';

const claimFormBAPI = {
  /**
   * Get all Claim Forms B with filters
   * @param {Object} params - Query parameters (status, patientSearch, startDate, endDate, page, limit)
   */
  getAllForms: async (params = {}) => {
    try {
      const response = await api.get(BASE_URL, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching Claim Forms B:', error);
      throw error;
    }
  },

  /**
   * Get Claim Form B by ID
   * @param {string} formId - Form ID
   */
  getFormById: async (formId) => {
    try {
      const response = await api.get(`${BASE_URL}/${formId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching Claim Form B:', error);
      throw error;
    }
  },

  /**
   * Create a new Claim Form B
   * @param {Object} formData - Form data
   */
  createForm: async (formData) => {
    try {
      const response = await api.post(BASE_URL, formData);
      return response.data;
    } catch (error) {
      console.error('Error creating Claim Form B:', error);
      throw error;
    }
  },

  /**
   * Update a Claim Form B (only drafts)
   * @param {string} formId - Form ID
   * @param {Object} formData - Updated form data
   */
  updateForm: async (formId, formData) => {
    try {
      const response = await api.put(`${BASE_URL}/${formId}`, formData);
      return response.data;
    } catch (error) {
      console.error('Error updating Claim Form B:', error);
      throw error;
    }
  },

  /**
   * Submit a Claim Form B
   * @param {string} formId - Form ID
   */
  submitForm: async (formId) => {
    try {
      const response = await api.post(`${BASE_URL}/${formId}/submit`);
      return response.data;
    } catch (error) {
      console.error('Error submitting Claim Form B:', error);
      throw error;
    }
  },

  /**
   * Delete a Claim Form B (only drafts)
   * @param {string} formId - Form ID
   */
  deleteForm: async (formId) => {
    try {
      const response = await api.delete(`${BASE_URL}/${formId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting Claim Form B:', error);
      throw error;
    }
  },

  /**
   * Get all Claim Forms B for a specific patient
   * @param {string} patientId - Patient ID
   */
  getPatientForms: async (patientId) => {
    try {
      const response = await api.get(`${BASE_URL}/patient/${patientId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching patient Claim Forms B:', error);
      throw error;
    }
  }
};

export default claimFormBAPI;
